import fetch from "./fetch";
/**
 * 培训管理
 */
const training = {
  //培训列表详情
  getTrainingDetail(params) {
    return fetch({
      isLoading: true,
      url: "/trainData/detail",
      method: "GET",
      params,
    });
  },
  //培训新增
  saveTrainingData(data) {
    return fetch({
      isLoading: true,
      url: "/trainData/save",
      method: "POST",
      data,
    });
  },
  //培训修改
  updateTrainingData(data) {
    return fetch({
      isLoading: true,
      url: "/trainData/update",
      method: "POST",
      data,
    });
  },
  //培训列表分页
  getTrainingPage(params) {
    return fetch({
      isLoading: true,
      url: "/trainData/page",
      method: "GET",
      params,
    });
  },

  //培训记录分页
  getTrainingRecord(params) {
    return fetch({
      isLoading: true,
      url: "/trainRecord/page",
      method: "GET",
      params,
    });
  },
};

export default training;
